import React from 'react'
import ReactLoadable from 'react-loadable'
import { LoadingIndicator } from '@app/components/LoadingIndicator'

export default ReactLoadable({
  loader: () => import('./index'),
  loading: () => <LoadingIndicator />
})
